// extracted by mini-css-extract-plugin
export var cardIcon = "_6h-5";
export var cardIconUnframed = "_6h-9";
export var checkboxCard = "_6h-0";
export var checkboxCardSelected = "_6h-4";
export var disabled = "_6h-2";
export var interactive = "_6h-1";
export var outerBorder = "_6h-3";
export var spacerMedium = "_6h-8";
export var spacerSmall = "_6h-7";
export var spacerXsmall = "_6h-6";